<template>
    <li
        class="house-slider-item"
        :class="{ mobile: isMobile, 'house-sold': soldDate }"
        :title="address"
        @click="openDetail(link, $event)"
    >
        <a
            class="house-preview"
            :href="linkData.href"
            :target="linkData.target"
            :aria-label="linkData['aria-label']"
            :self="linkData.self"
        >
            <site-img
                class="house-img"
                :src="firstImage"
                :errorImg="defHouseImg"
                dir="width"
            />
            <div
                class="img-mask"
                v-if="maskOption.showMask"
                :style="{
                    backgroundColor: maskOption.maskColor
                }"
            ></div>
            <house-mask v-if="isShowMask" display="fill-up" />
            <div class="house-info-box">
                <p v-if="soldDate" :class="['house-sold-date', statusOrigin]">
                    <only-client>
                        <span>{{ $t('md-house.soldOn', {soldDate: $ft.formatDate(soldDate, 'MM/dd/yyyy')}) }}</span>
                    </only-client>
                </p>
                <div class="house-info">
                    <div class="house-address">
                        <a
                            :href="linkData.href"
                            :target="linkData.target"
                            :aria-label="linkData['aria-label']"
                            :self="linkData.self"
                        >{{ address }}</a>
                    </div>
                    <div class="price-fav">
                        <div class="house-price-wrap">
                            <title-mask-v2 v-if="isShowMask" />
                            <no-disclosure
                                v-else-if="!!house.nodisclosureDes || hidePrice"
                                :des="
                                    hidePrice
                                        ? $t('md-house.nondisclosure')
                                        : house.nodisclosureDes
                                "
                            />
                            <span v-else class="house-price">{{
                                housePrice
                            }}</span>
                            <template v-if="soldDate && !isShowMask">
                                <span
                                    class="house-initial-price"
                                    v-if="showAllPrice && initialPrice"
                                >
                                    {{ $ft.trim(initialPrice) }}
                                </span>
                                <HouseTrend
                                    v-if="showAllPrice && trend"
                                    :trendStatus="trendStatus"
                                    :trend="trend"
                                />
                            </template>
                        </div>
                    </div>
                    <div class="house-basic">
                        <span v-for="item in basic" :key="item.key">{{
                            item.text
                        }}</span>
                    </div>
                </div>
                <div class="house-mls" :class="{ 'sold-mls-info': !!soldDate }">
                    <div class="mls-provided">
                        <p v-if="showMls" class="house-mls-id">
                            MLS# {{ mlsid }}
                        </p>
                        <p v-if="provided" class="house-provided ws-pre-wrap">
                            {{ provided }}
                        </p>
                    </div>
                    <site-img
                        v-if="mlsLogo"
                        class="small-logo"
                        :src="mlsLogo"
                        :alt="mlsAlt"
                        dir="width"
                    />
                </div>
            </div>
        </a>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </li>
</template>
<script>
import ItemForSearch from '../itemForSearch';
import HouseItem from '../house-item.js';
export default {
    mixins: [ItemForSearch, HouseItem],
    props: ['maskOption'],
    data: function() {
        return {
            // heartActive: false,
            // isShowMask: true
        };
    }
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-house.layout5 {
    .house-slider-item {
        position: relative;
        display: flex;
        flex-direction: column;

        .house-preview {
            display: block;
            width: 100%;
            height: 100%;
            position: relative;
            overflow: hidden;
            img.house-img {
                position: absolute;
                width: 100%;
                height: 100%;
                object-fit: cover;
                top: 0;
                left: 0;
                transition: transform 0.3s ease;
            }
            &:hover {
                img.house-img {
                    transform: scale(1.1);
                }
            }
            .img-mask {
                width: 100%;
                height: 100%;
                // opacity: 0.15;
                position: absolute;
                right: 0;
                bottom: 0;
                top: 0;
                left: 0;
                z-index: 2;
                overflow: hidden;
            }
        }

        .house-info-box {
            position: absolute;
            z-index: 20;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            padding: 50px;
            .house-sold-date {
                margin-bottom: 20px;
                span {
                    font-family: var(--font-normal);
                    font-size: 12px;
                    font-weight: 700;
                    height: 20px;
                    line-height: 20px;
                    padding: 0 5px;
                    border-radius: 0;
                    color: #fff;
                    background-color: #505050;
                }
            }

            .house-info {
                .house-address {
                    color: #fff;
                    font-family: var(--font-title);
                    font-size: 34px;
                    font-weight: 700;
                    line-height: 51px;
                    text-align: left;
                    @include webkitBox(2);
                    margin-bottom: 10px;
                    a {
                        font-weight: inherit;
                    }
                }
                .price-fav {
                    margin-bottom: 10px;
                    .nodisclosure {
                        .dollar,
                        .secret {
                            color: var(--color-success);
                        }
                    }
                    .house-price-wrap {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        column-gap: 10px;
                        .house-price {
                            color: #fff;
                            font-size: 20px;
                            font-weight: 400;
                            line-height: 27px;
                            text-align: left;
                            @include media-800 {
                                font-size: 18px;
                            }
                        }
                        .house-initial-price {
                            color: #fff;
                            font-size: 16px;
                            font-weight: 400;
                            line-height: 19.5px;
                            text-align: left;
                            text-decoration: line-through;
                            opacity: 0.7;
                        }
                    }
                }
                .house-basic {
                    color: #fff;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 21px;
                    text-align: left;
                    span {
                        &:not(:last-child)::after {
                            content: '|';
                            display: inline;
                            padding: 0 8px;
                        }
                    }
                }
            }

            .house-mls {
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: absolute;
                bottom: 50px;
                left: 50px;
                right: 50px;
                .mls-provided {
                    opacity: 0.8;
                }
                .house-mls-id,
                .house-provided {
                    font-size: 12px;
                    line-height: 20px;
                    color: #fff;
                    @include webkitBox(2);
                    @include media-600 {
                        line-height: 12px;
                    }
                }
                .house-provided {
                    margin-top: 5px;
                }
                .small-logo {
                    height: 24px;
                }
            }
        }

        @include media-800 {
            .house-info-box {
                padding: 15px;

                .house-info {
                    .house-address {
                        font-size: 20px;
                        font-weight: 700;
                        line-height: 30px;
                        margin-bottom: 5px;
                    }
                    .price-fav {
                        margin-bottom: 5px;
                        .house-price-wrap {
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                            column-gap: 10px;
                            .house-price {
                                font-size: 18px;
                            }
                        }
                    }
                }
                .house-mls {
                    bottom: 15px;
                    left: 15px;
                    right: 15px;
                }
            }
        }
    }
}
</style>
